import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
const LENGTH_OPTIONS = Object.freeze(['full', 'short']);
export default Helper.extend({
  intl: service(),
  compute([monthInt], {
    length = 'full'
  }) {
    if (monthInt < 1 || monthInt > 12) {
      // eslint-disable-next-line no-console
      console.warn('Passed month integer must be included in [1..12]');
    }
    if (!LENGTH_OPTIONS.includes(length)) {
      // eslint-disable-next-line no-console
      console.warn('Option "length" must be either "full" or "short"');
    }

    // eslint-disable-next-line square/no-translation-key-interpolation
    return this.intl.t(`enums.months.${length}.${monthInt}`);
  }
});